import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import DynamicPage from 'src/sections/one/DynamicPage';

// ----------------------------------------------------------------------
const WelcomePage = lazy(() => import('src/pages/dashboard/welcome'));
const IndexPage = lazy(() => import('src/pages/dashboard/one'));
const PageTwo = lazy(() => import('src/pages/dashboard/two'));
const PageThree = lazy(() => import('src/pages/dashboard/three'));
const PageTenants = lazy(() => import('src/pages/dashboard/tenants'));
const PageTenantCreate = lazy(() => import('src/pages/dashboard/tenantCreate'));

const PageProductivity = lazy(() => import('src/pages/dashboard/productivity'));
const PageFour = lazy(() => import('src/pages/dashboard/four'));
const PageFive = lazy(() => import('src/pages/dashboard/five'));
const PageSix = lazy(() => import('src/pages/dashboard/six'));
const PageLogs = lazy(() => import('src/pages/dashboard/logs'));
const UserProfile = lazy(() => import('src/pages/dashboard/UserProfile'));
const TenantProfile = lazy(() => import('src/pages/dashboard/tenantProfile'));
const PageAr = lazy(() => import('src/pages/dashboard/ar'));
const PageDenial = lazy(() => import('src/pages/dashboard/denials'));
const PageAction = lazy(() => import('src/pages/dashboard/action'));
const PageAdjustment = lazy(() => import('src/pages/dashboard/adjustments'));
const PagePro = lazy(() => import('src/pages/dashboard/pro'))
const PageAdminArticles = lazy(() => import('src/pages/dashboard/admin-articles'))

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <WelcomePage />, index: true },
      { path: 'main', element:  <IndexPage />},
      { path: 'kpi', element:  <PageTwo />},
      { path: 'zip', element: <PageThree /> },
      { path: 'productivity', element: <PageProductivity  /> },
      { path: 'ar', element: <PageAr  /> },
      { path: 'adjustment', element: <PageAdjustment  /> },
      { path: 'denial', element: <PageDenial  /> },
      { path: 'action', element: <PageAction  /> },
      { path: 'pro', element: <PagePro  /> },
      {
        path: 'admin',
        children: [
          { element: <PageFour />, index: true },
          { path: 'five', element: <PageFive /> },
          { path: 'six', element: <PageSix /> },
          { path: 'logs', element: <PageLogs /> },
          { path: 'tenants', element: <PageTenants />},
          {path: 'tenants/create', element: <PageTenantCreate />},
          {path: 'articles', element: <PageAdminArticles />}
        ],
        
      },
      { path: 'user-profile/:id', element: <UserProfile /> },
      { path: 'tenant-profile/:id', element: <TenantProfile /> }, 
    ],
  },
];
